export default "__VITE_ASSET__0Yg1yd9Q__"